<template>
  <div id="main">
    <span class="tip">対象のファイルをアップロードしてください</span>
    <table class="table table-file-type">
      <tbody>
        <tr>
          <td>Amazon</td>
          <td>注文レポート.txtと出品レポート.txt</td>
        </tr>
        <tr>
          <td>日本の古本屋</td>
          <td>古本屋のピックアップリスト.csv</td>
        </tr>
        <tr>
          <td>ヤフオク</td>
          <td>Yahoo!-order.csv</td>
        </tr>
      </tbody>
    </table>
    <table class="upload-contents">
      <thead>
        <tr>
          <th class="col-button"><FileUpload @uploadFile="uploadFile" /></th>
          <th><h3><CheckedMark :checked="uploadDataType.imported" :failureMark="true"></CheckedMark></h3></th>
          <th class="col-logo-image"><img class="csv-image" :src="uploadDataType.src"> </th>
          <th class="col-note">
            <div v-if="uploadDataType.imported">
              データ数：{{getShippingDataCount}}
            </div>
          </th>
        </tr>
      </thead>
    </table>

    <span v-if="uploadDataType.Index === UploadDataType.Amazon.Index" class="tip">出品レポート.txtをアップロードしてください</span>
    <table class="upload-contents" v-if="uploadDataType.Index === UploadDataType.Amazon.Index">
      <thead>
        <tr>
          <th class="col-button"><FileUpload @uploadFile="uploadAmazonIsbnFile" /></th>
          <th><h3><CheckedMark :checked="uploadedAmazonIsbnData" :failureMark="true"></CheckedMark></h3></th>
          <th class="col-note">
          </th>
        </tr>
      </thead>
    </table>

  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import createStore from '@/store/index.js'
import FileUpload from '@/components/FileUploader.vue'
import { ShippingStep, UploadDataType } from '@/const/const'
import { uploadShippingData, uploadAmazonIsbnData } from '@/js/shipping/upload.js'
import CheckedMark from '@/components/CheckedMark.vue'

export default defineComponent({
  components: {
    FileUpload,
    CheckedMark
  },
  props: {
    stepStatus: {
      default: ShippingStep.Step1
    }
  },
  setup (props) {
    const store = createStore

    const img = ref(require('@/assets/upload/Amazon_logo.png'))

    const uploadFile = (res) => {
      uploadShippingData(res.file)
    }

    const uploadAmazonIsbnFile = (res) => {
      uploadAmazonIsbnData(res.file)
    }

    const getShippingDataCount = computed(() => {
      console.log(uploadDataType)
      return store.getters.getShippingData.length
    })

    const uploadDataType = computed(() => {
      return store.getters.uploadDataType
    })

    const uploadedAmazonIsbnData = computed(() => {
      return store.getters.uploadAmazonIsbnData
    })

    const isUploadShippingData = computed(() => {
      return store.getters.isUploadedShippingData
    })

    return {
      img,
      uploadFile,
      uploadAmazonIsbnFile,
      getShippingDataCount,
      isUploadShippingData,
      uploadedAmazonIsbnData,
      uploadDataType,
      UploadDataType
    }
  }
})
</script>

<style lang="scss" scoped>
  #main {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    width: 80%;
    margin-left: auto;
    margin-right: auto;

    position: relative;
    text-align: left;
    height: 100%;
    padding-top: 1rem;
    padding-left: 3rem;
    .tip {
      margin-top: 1rem;
      margin-bottom: 1rem;
      padding: 0.5rem;
      background: white;
    }
    .table-file-type {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
      width: 40%;
      background-color: white;
      color: #333333;
      td {
        border-bottom: #333333;
      }
    }
    .upload-contents {
      position: relative;
      margin-top: 1rem;
      margin-bottom: 1rem;
      height: 5rem;
      width: 50%;
      border-radius: 6px;
      background: white;
      outline: 2px solid gray;
      tr {
        height: 100%;
        width: 100%;
        .col-checked-mark {
          font-size: xx-large;
          font-weight: bold;
          width: 3rem;
        }
        .col-button {
          width: 10rem;
        }
        .col-note {
          margin-top: 1rem;
        }
        .col-logo-image {
          height: 100%;
          .csv-image {
            height: 40px;
            object-fit: contain;
          }
        }
      }
    }
  }
</style>
